import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import VehicleListPage from './pages/VehicleListPage';
import VehicleDetailPage from './pages/VehicleDetailPage';
import CheckoutPage from './pages/CheckoutPage';
import PaymentPage from './pages/PaymentPage';
import SuccessPage from './pages/SuccessPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailPage from './pages/PaymentFailPage';
import ExtensionPaymentSuccessPage from './pages/ExtensionPaymentSuccessPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ReservationSearchPage from './pages/ReservationSearchPage';
import ReservationDetailPage from './pages/ReservationDetailPage';
import TermsPage from './pages/TermsPage';
import ReviewFormPage from './pages/ReviewFormPage';
import RentalGuidePage from './pages/RentalGuidePage';
import ServiceGuidePage from './pages/ServiceGuidePage';
import VipPage from './pages/VipPage';
import KakaoCallbackPage from './pages/KakaoCallbackPage';
import MyCouponsPage from './pages/MyCouponsPage';
import MyReservationsPage from './pages/MyReservationsPage';

// Naver Analytics 페이지뷰 추적 컴포넌트
function NaverAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // 페이지 전환 시마다 네이버 애널리틱스 추적
    if (window.wcs && window.wcs_do) {
      window.wcs_do();
    }
  }, [location.pathname]);

  return null;
}

// TypeScript용 window.wcs 타입 선언
declare global {
  interface Window {
    wcs?: any;
    wcs_do?: () => void;
    wcs_add?: any;
  }
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <NaverAnalytics />
        <div className="min-h-screen">
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vehicles" element={<VehicleListPage />} />
          <Route path="/vehicle-detail" element={<VehicleDetailPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/fail" element={<PaymentFailPage />} />
          <Route path="/extension-payment-success" element={<ExtensionPaymentSuccessPage />} />
          <Route path="/extension-payment-fail" element={<PaymentFailPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/reservation" element={<ReservationSearchPage />} />
          <Route path="/reservation/detail" element={<ReservationDetailPage />} />
          <Route path="/reservation/:reservationNumber" element={<ReservationDetailPage />} />
          <Route path="/review/:token" element={<ReviewFormPage />} />
          <Route path="/rental-guide" element={<RentalGuidePage />} />
          <Route path="/vip" element={<VipPage />} />
          <Route path="/service-guide" element={<ServiceGuidePage />} />
          <Route path="/auth/kakao/callback" element={<KakaoCallbackPage />} />
          <Route path="/my-coupons" element={<MyCouponsPage />} />
          <Route path="/my-reservations" element={<MyReservationsPage />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
